import React, { useEffect, useState } from "react";
import GetMonthsOpt from "../Dropdowns/getSelectMonth.js";
import GetYearsOpt from "../Dropdowns/getSelectYear.js";
import GetDistricts from "../Dropdowns/getDistricts.js";
import GenericDropdown from "../Dropdowns/GenericDropdown.js";
import RegenerateCommissionNFSAStateDetails from "./RegenerateCommissionNFSAStateDetails.jsx";

const RegenerateCommissionNFSAState = () => {
  const [loading, setLoading] = useState(true);
  const [selectedDistCode, setSelectedDistCode] = useState("");
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [renderContent, setRenderContent] = useState(null);

  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  const handleMonthsLoadingChange = (isLoading) => {
    handleLoadingChange(isLoading);
  };

  const handleYearsLoadingChange = (isLoading) => {
    handleLoadingChange(isLoading);
  };

  const handleDistrictChange = (dist_code) => {
    setSelectedDistCode(dist_code);
  };

  const handleSubmit = async () => {
    const month = document.getElementById("month").value;
    const year = document.getElementById("year").value;
    const distCode = document.getElementById("dist_code").value;
    const allotMonth = document.getElementById("allotMonth").value;
    const allotYear = document.getElementById("allotYear").value;

    const distMonthName =
      document.getElementById("month").options[
        document.getElementById("month").selectedIndex
      ].text;

    const alotMonthName =
      document.getElementById("allotMonth").options[
        document.getElementById("allotMonth").selectedIndex
      ].text;

    const districtName =
      document.getElementById("dist_code").options[
        document.getElementById("dist_code").selectedIndex
      ].text;

    if (month == null || month == "") {
      alert("Please select Distribution Month");
      return false;
    } else if (year == null || year == "") {
      alert("Please select Distribution Year");
      return false;
    } else if (allotMonth == null || allotMonth == "") {
      alert("Please select Allotted Month");
      return false;
    } else if (allotYear == null || allotYear == "") {
      alert("Please select Allotted Year");
      return false;
    } else if (distCode == null || distCode == "") {
      alert("Please select District");
      return false;
    } else {
      setRenderContent(null);
      setRenderContent(
        <RegenerateCommissionNFSAStateDetails
          month={month}
          year={year}
          allotMonth={allotMonth}
          allotYear={allotYear}
          distCode={distCode}
          distMonthName={distMonthName}
          alotMonthName={alotMonthName}
          districtName={districtName}
        />,
      );
    }
  };

  return (
    <div
      className="wrapper row3"
      style={{ paddingBottom: "40px" }}
    >
      <div id="container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10px",
          }}
        >
          <table width="70%">
            <thead>
              <tr className="tableheader">
                <th colSpan={12}>Regenerate Commission for NFSA and State</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Distribution Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="month"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>
                <td>Distribution Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="year"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>
                <td>Allotment Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="allotMonth"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>
                <td>Allotment Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="allotYear"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>
                <td>District :</td>
                <td>
                  <GetDistricts
                    onLoadingChange={setLoadingDistricts}
                    onChange={handleDistrictChange}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="12" align="center">
                  {
                    <button
                      className="button button2"
                      style={{ marginRight: "10px" }}
                      onClick={handleSubmit}
                    >
                      {" "}
                      Submit
                    </button>
                  }
                  <button
                    className="button button2"
                    onClick={() => window.history.back()}
                  >
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <div id="loading" style={{ display: "none", textAlign: "center" }}>
          <img src="images/progress.gif" alt="Loading" />
        </div>
        <br />
        <div id="regenerateCommission" style={{ paddingLeft: "0%" }}>
          {renderContent}
        </div>
      </div>
    </div>
  );
};
export default RegenerateCommissionNFSAState;
